<!--
Use ngx-loading-bar/http-client when load this page.
-->
<ngx-loading-bar [color]="'white'"></ngx-loading-bar>
<!-- / -->

<main class="w-full px-4">
  <div class="mx-auto max-w-7xl">
    <ng-container *ngIf="cart?.id; else loading">
      <!-- Breadcrumbs -->
      <nav class="flex mt-12" aria-label="Breadcrumb">
        <ol role="list" class="flex items-center space-x-4">
          <li>
            <div>
              <a [routerLink]="['/']" class="text-gray-400 hover:text-pink-800">
                <svg class="h-5 w-5 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fill-rule="evenodd" d="M9.293 2.293a1 1 0 011.414 0l7 7A1 1 0 0117 11h-1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-3a1 1 0 00-1-1H9a1 1 0 00-1 1v3a1 1 0 01-1 1H5a1 1 0 01-1-1v-6H3a1 1 0 01-.707-1.707l7-7z" clip-rule="evenodd" />
                </svg>
                <span class="sr-only">Início</span>
              </a>
            </div>
          </li>

          <li>
            <div class="flex items-center">
              <svg class="h-5 w-5 flex-shrink-0 text-pink-800" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                <path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z" />
              </svg>
              <a [routerLink]="['/p/cart']" [queryParams]="{uid: cart.client_marketplace_cart_uid}" class="ml-4 text-sm font-medium text-gray-500 hover:text-pink-800" aria-current="page">Carrinho</a>
            </div>
          </li>

          <li>
            <div class="flex items-center">
              <svg class="h-5 w-5 flex-shrink-0 text-pink-800" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                <path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z" />
              </svg>
              <a class="ml-4 text-sm font-medium text-gray-500 hover:text-pink-800" aria-current="page">Finalizar Compra</a>
            </div>
          </li>
        </ol>
      </nav>

      <ng-container *ngIf="cart.products.length > 0">
        <div class="py-16 lg:grid lg:grid-cols-2 lg:gap-x-12 xl:gap-x-16">
          <!-- Order summary -->
          <section class="rounded-lg bg-gray-50 px-4 py-6 sm:p-6 lg:p-8 h-fit">
            <h2 class="text-lg font-medium text-gray-900">Resumo da Compra</h2>

            <dl class="mt-6 space-y-4">
              <div class="flex items-center justify-between">
                <dt class="text-sm text-gray-600">Subtotal ({{cart.counter_item}} itens)</dt>
                <dd class="text-sm font-medium text-gray-900">R${{cart.price_gross | number:'1.2-2'}}</dd>
              </div>

              <div class="flex items-center justify-between border-t border-gray-200 pt-4">
                <dt class="text-sm text-gray-600">
                  Frete <ng-container *ngIf="cart.delivery_merchant !== null"> via <span class="font-bold">{{cart.delivery_merchant}}</span></ng-container> <br />
                  <ng-container *ngIf="cart.zipcode != null && cart.zipcode != ''"><small class="d-block">CEP: {{cart.zipcode}}.</small></ng-container>
                </dt>
                <div class="flex justify-between items-center space-x-2">
                  <ng-container *ngIf="cart.delivery_free == 'yes'">
                    <dd class="text-sm font-medium text-gray-900">Grátis</dd>
                  </ng-container>
                  <ng-container *ngIf="cart.price_delivery != 0 && cart.delivery_free == 'no'">
                    <dd class="text-sm font-medium text-gray-900">R${{cart.price_delivery | number:'1.2-2'}}</dd>
                  </ng-container>
                  <ng-container *ngIf="cart.awaiting_user_apply_delivery_method && cart.charging_address !== null">
                    <div class="rounded-lg border border-red-600 bg-red-100 p-2">
                      <p class="text-xs text-red-900 lg:text-sm">Escolha o <button class="underline" (click)="collectiveMarketplaceCartServicePriceDelivery(cart.charging_address)">Método de Entrega</button>.</p>
                    </div>
                  </ng-container>
                </div>
              </div>

              <ng-container *ngIf="cart.client_marketplace_core_voucher_id != null">
                <div class="flex items-center justify-between border-t border-gray-200 pt-4">
                  <dt class="text-sm text-gray-600">Desconto <br /><small class="d-block" *ngIf="cart.voucher != null">Cupom: {{cart.voucher.name | uppercase}}.</small></dt>

                  <div class="flex flex-col items-end space-y-1">
                    <ng-container *ngIf="cart.voucher != null">
                      <div class="text-sm font-medium text-gray-900">- R${{cart.price_discount | number:'1.2-2'}}</div>
                    </ng-container>
                    <ng-container>
                      <button (click)="collectiveMarketplaceCartServiceVoucherEmpty()" class="underline text-amber-500 text-xs hover:text-amber-600">Remover Cupom</button>
                    </ng-container>
                  </div>
                </div>
              </ng-container>

              <div class="flex items-center justify-between border-t border-gray-200 pt-4">
                <dt class="text-base font-medium text-gray-900">Total</dt>
                <div class="flex flex-col items-end">
                  <dd class="text-base font-medium text-gray-900">R${{cart.price_accumulated | number:'1.2-2'}}</dd>
                  <ng-container *ngIf="marketplace?.payment?.credit_card_max_installment_no_fee > 0"> <p class="text-sm font-medium text-gray-900">Até {{marketplace.payment.credit_card_max_installment_no_fee}}x sem juros*</p> </ng-container>
                </div>
              </div>
            </dl>
          </section>
          <div class="mt-10 lg:mt-0">
            <h2 class="text-lg font-medium text-gray-900">Endereço de Entrega</h2>

            <ng-container *ngIf="cart.charging_address == null">
              <div class="space-y-3 mt-4">
                <ng-container *ngFor="let address of customer_addresses?.data">
                  <div class="border border-gray-200 p-2 rounded-lg">
                    <div class="flex justify-between space-x-4 p-2">
                      <div class="flex justify-between space-x-4">
                        <div>
                          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 lg:w-6 lg:h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                            <path stroke-linecap="round" stroke-linejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                          </svg>
                        </div>
                        <div>
                          <p class="text-sm"><span class="font-bold">{{address.street}}, {{address.number}}</span> <span *ngIf="address.complement != ''"> / {{address.complement}}</span> {{address.city}}, {{address.state}} - {{address.zipcode}}</p>
                        </div>
                      </div>
                      <div>
                        <button (click)="collectiveMarketplaceCartServicePriceDelivery(address)" class="rounded-lg px-3 py-2 bg-[#FFBE0B] text-black text-xs lg:text-sm lg:px-3 lg:py-3 hover:bg-amber-500">Escolher</button>
                      </div>
                    </div>
                  </div>
                </ng-container>
                <div class="flex flex-col items-center">
                  <button [routerLink]="['/a/address/store', {redirect: '/p/checkout'}]" class="rounded-lg px-4 py-3 bg-[#FFBE0B] text-black text-xs lg:text-sm hover:bg-amber-500">Cadastrar um novo endereço</button>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="cart.charging_address != null">
              <div class="border border-gray-200 p-2 rounded-lg mt-4">
                <div class="flex items-center space-x-2 p-2">
                  <div class="self-start">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path stroke-linecap="round" stroke-linejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </div>
                  <div>
                    <p class="text-sm"><span class="font-bold">{{cart.charging_address.street}}, {{cart.charging_address.number}}</span><span *ngIf="cart.charging_address.complement != ''"> / {{cart.charging_address.complement}}</span>. {{cart.charging_address.city}}, {{cart.charging_address.state}} - {{cart.charging_address.zipcode}}.</p>
                  </div>
                </div>
              </div>
              <p class="mt-2 text-center text-gray-600 text-sm">
                <button (click)="collectiveMarketplaceCartServiceAddressEmpty();">Alterar <strong class="underline text-amber-400">Endereço de Entrega</strong></button> ou <button class="underline text-amber-400" (click)="collectiveMarketplaceCartServiceAddressEmpty();">Método de Entrega</button>.
              </p>
            </ng-container>

            <!-- Payment -->
            <div class="mt-10 border-t border-gray-200 pt-10">
              <h2 class="text-lg font-medium text-gray-900">Forma de Pagamento</h2>

              <fieldset class="mt-4">
                <div class="space-y-4 sm:flex sm:items-center sm:space-y-0 sm:space-x-10">
                  <ng-container *ngIf="marketplace?.payment.accept_credit_card == 'yes'">
                    <div class="flex items-center">
                      <input name="payment_method" [(ngModel)]="cart.payment_method" #cart.payment_method="ngModel" value="credit_card" type="radio" checked class="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500" />
                      <label class="ml-3 block text-sm font-medium text-gray-700">Cartão de Crédito</label>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="marketplace?.payment.accept_pix == 'yes'">
                    <div class="flex items-center">
                      <input name="payment_method" [(ngModel)]="cart.payment_method" #cart.payment_method="ngModel" value="pix" type="radio" class="h-4 w-4 border-gray-300 text-pink-800 focus:ring-pink-500" />
                      <div>
                        <label class="ml-3 block text-sm font-medium text-gray-700">Pix</label>
                        <ng-container *ngIf="marketplace.payment.discount_percent_pix > 0">
                          <small class="ml-3 text-sm text-pink-800 font-medium">{{marketplace.payment.discount_percent_pix}}% de desconto.</small>
                        </ng-container>
                      </div>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="marketplace?.payment.accept_boleto == 'yes'">
                    <div class="flex items-center">
                      <input name="payment_method" [(ngModel)]="cart.payment_method" #cart.payment_method="ngModel" value="boleto" type="radio" class="h-4 w-4 border-gray-300 text-pink-800 focus:ring-pink-500" />
                      <div>
                        <label class="ml-3 block text-sm font-medium text-gray-700">Boleto</label>
                        <ng-container *ngIf="marketplace.payment.discount_percent_boleto > 0">
                          <small class="ml-3 text-sm text-pink-800 font-medium">10% de desconto. </small>
                        </ng-container>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </fieldset>
              <ng-container *ngIf="cart.payment_method == 'credit_card'">
                <div class="mt-10 flex flex-col space-y-4">
                  <div>
                    <p class="text-base font-bold">Cartão de Crédito</p>
                    <ng-container *ngIf="marketplace.payment.credit_card_max_installment > 0">
                      <p class="text-sm -pt-4">Parcele em até {{marketplace.payment.credit_card_max_installment}}x.</p>
                    </ng-container>
                  </div>
                  <ng-container *ngIf="creditcards?.length == 0">
                    <div class="flex flex-col items-center">
                      <button type="button" class="rounded-lg px-3 py-2 bg-[#FFBE0B] text-black text-sm" (click)="displayCreateCreditCardModal=true">Cadastrar <strong>Cartão de Crédito</strong></button>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="creditcards?.length > 0">
                    <p *ngIf="creditcards?.length > 1" class="text-sm font-bold text-pink-800">Escolha um Cartão de Crédito</p>
                    <select name="client_marketplace_customer_payment_method_creditcard_id" [(ngModel)]="transaction.client_marketplace_customer_payment_method_creditcard_id" #transaction.client_marketplace_customer_payment_method_creditcard_id="ngModel" class="flex w-full border border-gray-300 text-gray-900 text-sm rounded-full p-2">
                      <option value="{{creditcard.id}}" *ngFor="let creditcard of creditcards;">**** **** **** {{creditcard.creditcard_number_end}} | {{creditcard.holder_name}}</option>
                    </select>
                    <ng-container *ngIf="calc_installments">
                      <ng-container *ngIf="marketplace.payment.credit_card_max_installment > 0">
                        <div class="mt-2">
                          <select name="gateway_installments" [(ngModel)]="transaction.gateway_installments" #transaction.gateway_installments="ngModel" class="border border-gray-300 text-gray-900 text-sm rounded-full p-2 font-bold w-full">
                            <option value="{{installment[0]}}" *ngFor="let installment of calc_installments" class="block w-full">
                              {{installment[0]}}x de R$ {{installment[1] | number:'1.2-2'}}
                              <ng-container *ngIf="installment[3]"> com juros </ng-container>
                            </option>
                          </select>
                        </div>
                      </ng-container>
                    </ng-container>
                    <div class="mt-4 flex flex-col items-center">
                      <button (click)="displayCreateCreditCardModal=true" class="rounded-lg px-3 py-2 bg-[#FFBE0B] text-black text-sm hover:bg-amber-500">Cadastrar novo cartão</button>
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </div>
            <ng-container *ngIf="subscriptionAvailable?.id">
              <div class="mt-10 border-t border-gray-200 pt-10">
                <h2 class="text-lg font-medium text-gray-900">Assinar Compra</h2>
                <div class="mt-4">
                  <p class="text-sm leading-4"><span class="font-semibold">Você pode assinar a sua compra</span> e receber de forma recorrente os produtos selecionados, aproveite essa novidade da Casa de Gê.</p>
                </div>

                <ng-container *ngIf="cart.payment_method == 'boleto' || cart.payment_method == 'pix' || cart.payment_method == 'undefined'">
                  <div class="rounded-lg border border-red-600 bg-red-100 p-2 mt-4">
                    <p class="text-xs font-bold uppercase text-red-800 lg:text-sm">Boleto bancário/Pix indisponível para assinatura</p>
                    <p class="text-xs text-red-900">Não é possível realizar o pagamento da assinatura por boleto bancário/pix, utilize outro meio de pagamento.</p>
                  </div>
                </ng-container>

                <ng-container *ngIf="cart.payment_method == 'credit_card'">
                  <div class="flex flex-col items-center border-2 border-gray-200 p-4 rounded-lg mt-4">
                    <div class="flex justify-between space-x-4">
                      <div>
                        <label class="font-bold text-sm pb-1 text-black">Período</label>
                        <select name="billing_cycle" [(ngModel)]="subscriptionExpectedOnThisOrder.billing_cycle" #subscriptionExpectedOnThisOrder.billing_cycle="ngModel" class="flex w-full border border-gray-300 text-gray-900 text-sm rounded-full p-2">
                          <option value="monthly" class="block w-full">Uma vez por mês</option>
                          <option value="weekly" class="block w-full">Uma vez por semana</option>
                          <option value="everyTenDays" class="block w-full">Uma vez a cada 10 dias</option>
                          <option value="everyFifteenDays" class="block w-full">Uma vez a cada 15 dias</option>
                          <option value="everyTwoMonths" class="block w-full">Uma vez a cada 2 meses</option>
                          <option value="everyThreeMonths" class="block w-full">Uma vez a cada 3 meses</option>
                          <option value="everySixMonths" class="block w-full">Uma vez a cada 6 meses</option>
                        </select>
                      </div>

                      <div>
                        <label class="font-bold text-sm pb-1 truncate text-black">Dia da Semana</label>
                        <select name="billing_cycle_weekday" [(ngModel)]="subscriptionExpectedOnThisOrder.billing_cycle_weekday" #subscriptionExpectedOnThisOrder.billing_cycle_weekday="ngModel" class="flex w-full border border-gray-300 text-gray-900 text-sm rounded-full p-2">
                          <option value="monday" class="block w-full">Segunda-feira</option>
                          <option value="tuesday" class="block w-full">Terça-feira</option>
                          <option value="wednesday" class="block w-full">Quarta-feira</option>
                          <option value="thursday" class="block w-full">Quinta-feira</option>
                          <option value="friday" class="block w-full">Sexta-feira</option>
                        </select>
                      </div>
                    </div>
                    <button class="bg-pink-800 rounded-full space-x-2 mt-6 hover:bg-pink-900" (click)="collectiveMarketplaceSubscriptionDone()">
                      <p class="text-white text-sm font-semibold p-4">Finalizar e assinar compra</p>
                    </button>
                    <p class="text-xs mt-5">
                      <span class="font-semibold">Economize <span *ngIf="subscriptionAvailable.price_discount_type == 'fixed'">R$ {{subscriptionAvailable.price_discount | number:'1.2-2'}}</span> <span *ngIf="subscriptionAvailable.price_discount_type == 'percent'">{{subscriptionAvailable.price_discount | number:'1.0-0'}}%</span></span> em suas compras ,
                      planejando uma assinatura de entrega recorrente do seu pedido. Seu pedido será refeito, de forma automática. Para processamento da sua assinatura, serão utilizados os mesmos dados do seu pedido.
                      <button (click)="collectiveMarketplaceCoreSubscriptionServiceDetail(subscriptionAvailable);" class="font-semibold underline italic">Consulte as regras.</button>
                    </p>
                  </div>
                  <div class="flex flex-col items-center mt-6">
                    <p class="text-xs text-center">Caso não queira assinar</p>
                    <button class="bg-[#FFBE0B] p-2 rounded-lg space-x-2 mt-2 hover:bg-amber-500" (click)="collectiveMarketplaceCartServiceDone();" [disabled]="messageProcess || cart.charging_address == null || cart.payment_method == 'undefined' || cart.delivery_method == ''">
                      <p class="text-black text-sm font-semibold">Finalizar somente esta compra</p>
                    </button>
                  </div>
                </ng-container>
              </div>
            </ng-container>
            <!-- avisos -->
            <div class="space-y-3 mt-10">
              <ng-container *ngIf="cart.charging_address == null">
                <div class="rounded-lg border border-red-600 bg-red-100 p-2">
                  <p class="text-xs font-bold uppercase text-red-800 lg:sm">Selecione um endereço para entrega</p>
                </div>
              </ng-container>
              <ng-container *ngIf="cart.delivery_method == null">
                <div class="rounded-lg border border-red-600 bg-red-100 p-2">
                  <p class="text-xs font-bold uppercase text-red-800 lg:sm">Selecione um método de entrega</p>
                </div>
              </ng-container>
              <ng-container *ngIf="cart.payment_method == 'undefined'">
                <div class="rounded-lg border border-red-600 bg-red-100 p-2">
                  <p class="text-xs font-bold uppercase text-red-800 lg:sm">Selecione uma forma de pagamento</p>
                </div>
              </ng-container>
            </div>

            <ng-container *ngIf="!subscriptionAvailable?.id || cart.payment_method != 'credit_card'">
              <p class="mt-4 mx-1 mb-8">
                <button type="button" class="bg-pink-800 rounded-full p-2 w-full text-sm font-semibold text-white hover:bg-pink-900" (click)="collectiveMarketplaceCartServiceDone();" [disabled]="messageProcess || cart.charging_address == null || cart.payment_method == 'undefined' || cart.delivery_method == ''">Finalizar compra</button>
              </p>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</main>

<!-- Modal tipo de entrega -->
<p-dialog header="Entrega no CEP: {{address_delivery_applied?.zipcode}}" [(visible)]="displayDeliveryMethodModal" [modal]="true" [breakpoints]="{'1920px': '40vw', '960px': '40vw', '640px': '80vw'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
  <div *ngIf="price_delivery?.shippingServices">
    <div class="flex w-full items-center justify-between my-4" *ngFor="let delivery of price_delivery.shippingServices">
      <div class="relative flex items-center space-x-3 rounded-lg w-full border border-gray-300 bg-white px-6 py-5 shadow-sm focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 hover:border-gray-400 cursor-pointer">
        <div class="flex-shrink-0 hidden lg:block">
          <img class="h-10 w-10 rounded-full" src="https://cdn-icons-png.flaticon.com/512/45/45880.png" alt="Caminhão de Entrega" />
        </div>
        <div class="min-w-0 flex-1" (click)="collectiveMarketplaceCartServiceApplyDeliveryMethod(delivery)">
          <a class="focus:outline-none">
            <span class="absolute inset-0" aria-hidden="true"></span>
            <p class="text-sm font-medium text-gray-900">{{delivery.name}}</p>
            <p class="lg:truncate text-sm text-gray-500">Prazo de Entrega: {{delivery.days}} dias.</p>
            <p class="lg:truncate text-sm text-gray-500">Valor da Entrega: R$ {{delivery.price | number:'1.2-2'}}.</p>
          </a>
        </div>
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button (click)="displayDeliveryMethodModal=false">Fechar</button>
  </ng-template>
</p-dialog>

<!-- Modal cartão de crédito -->
<p-dialog header="Novo Cartão de Crédito" [(visible)]="displayCreateCreditCardModal" [modal]="true" [breakpoints]="{'1920px': '40vw', '960px': '40vw', '640px': '80vw'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
  <form (ngSubmit)="customerFinancialPaymentMethodCreditcardServiceCreate();">
    <div class="mt-4 mb-5 space-y-3">
      <div>
        <label class="font-bold text-sm text-black mb-2">Número</label>
        <input class="rounded-full border-gray-500 w-full text-xs lg:text-sm" type="text" mask="0000 0000 0000 0000" placeholder="____-____-____-____" name="number" [(ngModel)]="creditcard.number" #creditcard.number="ngModel" />
      </div>
      <div>
        <label class="font-bold text-sm text-black mb-2">Nome do Titular</label>
        <input class="rounded-full border-gray-500 w-full text-xs lg:text-sm" type="text" placeholder="Nome como exibido no cartão" name="holder_name" [(ngModel)]="creditcard.holder_name" #creditcard.holder_name="ngModel" />
      </div>
      <div class="flex items-center space-x-2">
        <div>
          <label class="font-bold text-sm text-black mb-2">Mês de Validade</label>
          <select class="rounded-full border-gray-500 w-full text-xs lg:text-sm" name="expiry_month" [(ngModel)]="creditcard.expiry_month" #creditcard.expiry_month="ngModel">
            <option value="{{m}}" *ngFor="let m of m();">{{m}}</option>
          </select>
        </div>
        <div>
          <label class="font-bold text-sm text-black mb-2">Ano de Validade</label>
          <select class="rounded-full border-gray-500 w-full text-xs lg:text-sm" name="expiry_year" [(ngModel)]="creditcard.expiry_year" #creditcard.expiry_year="ngModel">
            <option value="{{y}}" *ngFor="let y of y();">{{y}}</option>
          </select>
        </div>
      </div>
      <div>
        <label class="font-bold text-sm text-black mb-2">Código de Segurança</label>
        <input class="rounded-full border-gray-500 w-full text-xs lg:text-sm" mask="0000" type="text" placeholder="____" name="cvv" [(ngModel)]="creditcard.cvv" #creditcard.cvv="ngModel" />
      </div>
      <div class="mt-2 flex flex-col items-center lg:mt-4">
        <button class="rounded-full px-4 py-3 bg-amber-400 text-white text-sm" type="submit">Cadastrar Cartão de Crédito</button>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <button (click)="displayCreateCreditCardModal=false" class="text-sm">Fechar</button>
  </ng-template>
</p-dialog>

<!-- Modal de assinatura -->
<ng-container *ngIf="subscription?.id">
  <p-dialog header="{{subscription.name}}" [(visible)]="displaySubscriptionModal" [modal]="true" [style]="{width: '90vw', height: '50vh'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <ng-container *ngIf="subscription.delivery_free == 'yes'">
      <p>Assine esse pedido e tenha <strong>Frete Grátis</strong>. <span *ngIf="subscription.delivery_free_min_buy_price > 0">Nas compras acima de {{subscription.delivery_free_min_buy_price | number:'1.2-2':'pt-BR'}}.</span></p>
    </ng-container>
    <ng-container *ngIf="subscription.delivery_price > 0">
      <p>Ao assinar esse pedido, você pagará uma <strong>taxa fixa</strong> de R$ {{subscription.delivery_price | number:'1.2-2':'pt-BR'}} no valor da entrega.</p>
    </ng-container>
    <p class="py-2">
      Economize
      <span *ngIf="subscription.price_discount_type == 'fixed'"><strong>R$ {{subscription.price_discount | number:'1.2-2':'pt-BR'}}</strong></span>
      <span *ngIf="subscription.price_discount_type == 'percent'"><strong>{{subscription.price_discount | number:'1.2-2':'pt-BR'}}%</strong></span>
      em suas compras, planejando uma assinatura de entrega recorrente do seu pedido.
    </p>
    <p class="py-2">
      <span *ngIf="subscription.price_fee_setup > 0"> Taxa de Ativação da recorrência, de R$ {{subscription.price_fee_setup | number:'1.2-2':'pt-BR'}}. </span>
      <span *ngIf="subscription.price_fee_recurring > 0">Após, R$ {{subscription.price_fee_recurring | number:'1.2-2':'pt-BR'}}, adicionais ao valor do seu pedido.</span>
    </p>
    <ng-template pTemplate="footer">
      <button (click)="displaySubscriptionModal=false">Fechar</button>
    </ng-template>
  </p-dialog>
</ng-container>

<ng-template #loading>
  <div class="my-10">
    <nav aria-label="Breadcrumb">
      <ol role="list" class="flex items-center space-x-4">
        <li>
          <div role="status" class="max-w-sm animate-pulse">
            <div class="bg-gray-200 rounded w-48 h-3 mb-4"></div>
          </div>
        </li>
      </ol>
    </nav>
    <div class="sm:grid sm:grid-cols-2 lg:items-start lg:gap-x-8 pt-12">
      <div class="cols-span-2 flex flex-col space-y-4">
        <div role="status" class="space-y-8 animate-pulse md:space-y-0 md:space-x-8 md:flex md:items-center w-full">
          <div class="flex items-center justify-center w-full h-72 bg-gray-300 rounded"></div>
        </div>
      </div>
      <div class="cols-span-1 mt-10 sm:mt-16 sm:px-0 lg:mt-0 flex flex-col space-y-4">
        <div role="status" class="space-y-8 animate-pulse md:space-y-0 md:space-x-8 md:flex md:items-center w-full">
          <div class="flex items-center justify-center w-full h-96 bg-gray-300 rounded"></div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
